import { makeRequest, CommonRequestOptions } from '../makeRequest';

export type SkillWeights = {
   weights: {
      training: Record<'value', number>;
      supervisor: Record<'value', number>;
   };
};

export type UpdatedSkillWeights = SkillWeights['weights'];

export async function getSkillWeights(common: CommonRequestOptions = {}): Promise<SkillWeights> {
   return makeRequest('get', '/skills/weights', common);
}

export async function updateSkillWeights(
   updatedSkillWeights: UpdatedSkillWeights,
   common: CommonRequestOptions = {}
): Promise<SkillWeights> {
   return await makeRequest('put', '/skills/weights', {
      ...common,
      body: updatedSkillWeights,
   });
}
